module.exports = __webpack_public_path__ + "img/home_select_coffee_machine.41aee575.webp";